import "./Loader.css";

const Loader = () => {
  return (
    <div className="text-center">
      <span className="loader"></span>
    </div>
  );
};

export {Loader};
